import React from "react";

function ExpiredRentalAgreementPage() {
  return (
    <div>
      <h1>Contrato Expirado. Obrigado por confiar na Guerin.</h1>
    </div>
  );
}

export default ExpiredRentalAgreementPage;
